var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 306,
    viewBox: "0 0 111 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9988 56.9738C-85.0012 107.974 7.07364 208.934 -124.671 250.124",
    stroke: "#292B2E",
    strokeWidth: 0.716136,
    strokeLinecap: "round",
    strokeDasharray: "3.14 3.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0631 41.2412L30.095 55.2827L93.1028 26.5859L37.0631 41.2412Z",
    fill: "#292B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8557 55.8288C29.7818 55.7965 29.7153 55.7494 29.6601 55.6906C29.6049 55.6317 29.5623 55.5623 29.5347 55.4865C29.5072 55.4107 29.4953 55.3301 29.4998 55.2495C29.5044 55.169 29.5252 55.0902 29.5611 55.0179L36.5292 40.9763C36.5671 40.9 36.6209 40.8327 36.687 40.7789C36.7531 40.7251 36.8299 40.6861 36.9123 40.6645L92.9522 26.0094C93.0966 25.9717 93.2499 25.9895 93.3818 26.0593C93.5137 26.1291 93.6146 26.2459 93.6646 26.3865C93.7145 26.5271 93.7099 26.6814 93.6517 26.8188C93.5934 26.9562 93.4857 27.0667 93.3499 27.1285L30.342 55.8253C30.2657 55.8601 30.183 55.8783 30.0992 55.8789C30.0155 55.8795 29.9325 55.8625 29.8557 55.8288ZM37.4764 41.7493L31.3746 54.0453L86.5492 28.916L37.4764 41.7493Z",
    fill: "#292B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8981 25.7894L48.1308 70.9186L37.1652 41.503L22.0491 23.8332L94.8981 25.7894Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 0.59678
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8862 40.8315L39.6106 47.9349L94.4135 25.9578L36.8862 40.8315Z",
    fill: "#292B2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2659 50.6889L39.3641 48.0996L31.1018 54.8561L40.2659 50.6889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.10f275d534c32f00e1cf69402350d15f.svg";
export { ForwardRef as ReactComponent };